import React from 'react';
import { createRoot } from 'react-dom/client';
import NewslettersShow from '../../src/newsletters_show/newsletters_show';
import DevexHighOrderComponent from '../../src/components/react/devex_high_order_component/devex_high_order_component';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('subscribe-newsletter');
  if (!container) return;
  const root = createRoot(container);

  root.render(
    <DevexHighOrderComponent>
      <NewslettersShow
        newsletter={JSON.parse(container.dataset.newsletter)}
        isSignedIn={JSON.parse(container.dataset.isSignedIn)}
      />
    </DevexHighOrderComponent>
  );
});
